import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PpoBalanceService {
  routePrefix = '/api/newCasePreApproval';

  constructor(private http: HttpClient) { }

  getPpoDiscount(requestId: number): Observable<any> {
    return this.http.get(`${this.routePrefix}/getPPOBalance/${requestId}`);
  }

  saveAmount(data): Observable<any> {
    return this.http.post(`${this.routePrefix}/save-amount`, data);
  }

}
